var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Form',{attrs:{"reg":_vm.reg},on:{"update:reg":function($event){_vm.reg=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }